import './definition.css';
import art3 from '../../assets/curve2.webp'

const Definition = () => {
  return (
    <div className='definition'>
        
        <div className="defContainer">  
               
            <div className="def-Content">  
                <h4>Medien bewusster konsumieren</h4>
                <div className="defboxs">
                    <div className="boxContent">
                        <h6>Mental Media Score für Texte</h6>
                        <p>Zeigt, wie gesund du liest </p>
                        <p>Von <span style={{color: 'forestgreen', fontWeight: 'bold'}}>&#40;positiv&#41;</span> bis <span style={{color: 'red', fontWeight: 'bold'}}>&#40;negativ&#41;</span></p>
                        <p>Für ausgewogenen Medienkonsum</p> 
                    </div>
                </div>
                <p className='defText'>Auch Worte haben Gewicht. Manche nähren, andere beladen. Der Mental-Media-Score macht das sichtbar, um es sich bewusst zu machen.</p>
            </div>
            <img className="art3" src={art3} alt='art'/>
            
            <div className="needBox">
                <div className="needBoxContent">
                    <h6>Warum wir ihn brauchen: Die erste Generation ohne Anleitung</h6>
                    <p>Eltern stehen heute zwischen Anspruch und Realität: Sie sollen Vorbild im digitalen Raum sein, aber es gibt keinen Kompass. Schulen bemühen sich um Medienkompetenz, doch oft fehlt das Werkzeug. Jugendliche sind ständig online, ohne Schutzfilter für ihr Gefühl. Menschen schalten ab, meiden Nachrichten und Medien.</p>
                    
                    <p>Der Mental-Media-Score gibt Orientierung. Er hilft, zu verstehen, was Inhalte emotional mit uns machen und macht Lust auf bewusstes Konsumieren und auf digitale Medien. </p>
                </div>
                <div className="listContent">
                    <div className='part1'>
                        <h6>Was der Mental-Media-Score kann</h6>
                        <div className='list-content-1'>
                            <li className='list1'>Misst die emotionale Wirkung von Texten </li>
                            <li className='list2'>Visualisiert diese Wirkung auf einer Skala - inspiriert vom Nutri-Score</li>
                            <li className='list3'>Nutzt fundierte Sentiment-Analyse statt Meinung</li>
                            <li className='list4'>Fördert Selbstreflexion im digitalen Alltag</li>
                        </div>
                    </div>
                    <div className="titleSection">
                        <h5>Ein Tool gegen Nachrichtenmüdigkeit und Doomscrooling</h5>
                    </div>
                    <div className='part2'>
                        <div className='part2-left'>
                            <h6>Die Entwicklung des Mental-Media-Scores</h6>
                            <p>Du siehst hier den ersten Prototyp unseres Tools, den du hier auf der Website testen kannst. Doch die Entwicklung geht weiter. Dafür brauche ich finanzielle Unterstützung.</p>
                        </div>
                        <div className='part2-right'>
                            <li className='list5'>Eine App mit weiteren Funktionen und persönlichen Analysen für unterwegs.</li>
                            <li className='list6'>Ein Browser-Plugin, das Inhalte direkt beim Lesen bewertet.</li>
                        </div>
                    </div>
                    <div className="titleSection">
                        <h5 >Wir entwickeln den Mental Media Score Schritt für Schritt, mit echten Menschen, echtem Feedback und einer klaren Mission. Wir freuen uns auf deine Unterstützung in Form von Geld, Netzwerk und Feedback.</h5>
                    </div>
                </div>
            </div>
            
            
        </div>
        
    </div>
  )
}

export default Definition